import {
    Box,
    Button,
    Container,
    Divider,
    Typography
} from "@mui/material";
import React from "react";

const TERMS_OF_USE_PDF_URL = "https://docs.google.com/document/d/16rH-d5PnAu9-qwaIlwWPizaH7lCzJWEmK2VnIjmqEEo/export?format=pdf";

const TermsOfUse: React.FC = () => {
    const lastUpdated = "January 2025";

    return (
        <Box>
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Typography variant="h2" component="h1" sx={{
                    textAlign: 'center',
                    mb: 4,
                    fontWeight: 'bold'
                }}>
                    Platform Terms of Use
                </Typography>

                <Typography variant="body2" sx={{
                    textAlign: 'center',
                    mb: 2,
                    color: 'text.secondary',
                    fontStyle: 'italic'
                }}>
                    Last Updated: {lastUpdated}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
                    <Button
                        component="a"
                        href={TERMS_OF_USE_PDF_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="outlined"
                        color="primary"
                    >
                        Download as PDF
                    </Button>
                </Box>

                <Box sx={{ maxWidth: 900, mx: 'auto' }}>
                    <Typography variant="h5" component="h2" sx={{ mb: 4, fontWeight: 'bold', textAlign: 'center' }}>
                        By using the Strong Mind Strong Performance (SMSP) platform, you agree to the following:
                    </Typography>

                    {/* Purpose of the Platform */}
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" component="h3" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                            Purpose of the Platform
                        </Typography>
                        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                            SMSP is an educational, non-clinical platform designed to support reflection, communication, and growth.
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 4 }} />

                    {/* Appropriate Use */}
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" component="h3" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                            Appropriate Use
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.8 }}>
                            Users agree to:
                        </Typography>
                        <Box component="ul" sx={{ pl: 4, mb: 0 }}>
                            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>Use the platform respectfully</Typography></li>
                            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>Not misuse tools or data</Typography></li>
                            <li><Typography variant="body1" sx={{ lineHeight: 1.8 }}>Follow program guidelines</Typography></li>
                        </Box>
                    </Box>

                    <Divider sx={{ my: 4 }} />

                    {/* Data & Privacy */}
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" component="h3" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                            Data &amp; Privacy
                        </Typography>
                        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                            Use of the platform is governed by SMSP&apos;s Data &amp; Privacy Summary and Guardian Consent forms.
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 4 }} />

                    {/* Safety & Reporting */}
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" component="h3" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                            Safety &amp; Reporting
                        </Typography>
                        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                            SMSP follows mandated reporting laws. Safety concerns may require external reporting.
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 4 }} />

                    {/* No Guarantees */}
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" component="h3" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                            No Guarantees
                        </Typography>
                        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                            SMSP supports growth, but outcomes are not guaranteed.
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 4 }} />

                    {/* Changes */}
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" component="h3" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                            Changes
                        </Typography>
                        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                            SMSP may update platform features or policies with notice when required.
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default TermsOfUse;
